module.exports = __webpack_public_path__ + "media/pages/Home/images/HealthyAndTasty-1154b08ca3d4181fc5b6a8e7d578556d.jpg";